import cx from 'classnames';
import styles from '../SignInPage/SignIn.module.scss';
import Image from 'next/image';
import { Activities } from '../../components/Activities';


export const PromoBlocks = ({ steps, image }) => {

  return(
    <div className={styles.stepsContainer}>
      <div className={cx(styles.stepImage)}>
        <Image alt="StepsImage" src={image} layout="fill" objectFit="cover" />
      </div>
      {steps.map((step, index) => (
        <div className={styles.stepRow} key={index}>
          <div className={styles.stepNumber}>
            <div className={styles.stepNumberText}>{index+1}</div>
          </div>
          <div className={styles.stepDescriptionText}>{step}</div>
        </div>
      ))}
    </div>
  )
}

export const PromoBlocksActivities = ({ steps, image, activities }) => {

  return(
    <div style={{width: '100%'}}>
      <div className={cx(styles.stepImageBig)}>
        <Image alt="StepsImage" src={image} layout="fill" objectFit="cover" />
      </div>
      <Activities activities={activities} className={styles.gearActivities} />
      <div className={styles.stepsOnlyContainer}>
        {steps.map((step, index) => (
          <div className={styles.stepRow} key={index}>
            <div className={styles.stepNumber}>
              <div className={styles.stepNumberText}>{index+1}</div>
            </div>
            <div className={styles.stepDescriptionText}>{step}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
